import { render, staticRenderFns } from "./AccessForbidden.vue?vue&type=template&id=5c738780&scoped=true"
import script from "./AccessForbidden.vue?vue&type=script&lang=js"
export * from "./AccessForbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c738780",
  null
  
)

export default component.exports